import { DocumentTypeWithVirtual, DocumentType } from 'support/types';
import { PropertyFilterType } from '../ListTable/types';
import { t } from 'i18next';

export const buildDocumentTypeFilter = (key: string, exclude?: Array<DocumentType>) => ({
  key,
  type: PropertyFilterType.dropdown,
  label: t('transactions:list.filter.messageTypes.label'),
  value: '',
  dropDownOptions: {
    dropdownValues: [
      { label: t('common:messageTypes.plural.ORDER'), value: DocumentType.order },
      {
        label: t('common:messageTypes.plural.ORDER_RESPONSE'),
        value: DocumentType.orderResponse,
      },
      {
        label: t('common:messageTypes.plural.DISPATCH_INSTRUCTION'),
        value: DocumentType.dispatchInstruction,
      },
      {
        label: t('common:messageTypes.plural.DISPATCH_INSTRUCTION_RESPONSE'),
        value: DocumentType.dispatchResponse,
      },
      {
        label: t('common:messageTypes.plural.SHIPPING_NOTICE'),
        value: DocumentType.shippingNotice,
      },
      { label: t('common:messageTypes.plural.INVOICE'), value: DocumentType.invoice },
      {
        label: t('common:messageTypes.plural.CREDIT_NOTE'),
        value: DocumentType.creditNote,
      },
      {
        label: t('common:messageTypes.plural.REMITTANCE_ADVICE'),
        value: DocumentType.remittanceAdvice,
      },
      {
        label: t('common:messageTypes.plural.PRODUCT_CATALOG'),
        value: DocumentType.productCatalog,
      },
      {
        label: t('common:messageTypes.plural.SALES_REPORT'),
        value: DocumentType.salesReport,
      },
      {
        label: t('common:messageTypes.plural.ACKNOWLEDGEMENT'),
        value: DocumentType.acknowledgement,
      },
      {
        label: t('common:messageTypes.plural.RECEIVAL_NOTICE'),
        value: DocumentType.receivalNotice,
      },
      { label: t('common:messageTypes.plural.UNKNOWN'), value: DocumentType.unknown },
    ].filter((option) => !exclude?.includes(option.value)),
  },
  eventDetails: {
    event: 'filter_changed',
    properties: {
      filter_type: 'documentType',
    },
  },
});

export const buildDocumentTypeFilterWithVirtual = (key: string, exclude?: Array<DocumentTypeWithVirtual>) => ({
  key,
  type: PropertyFilterType.dropdown,
  label: t('transactions:list.filter.messageTypes.label'),
  value: '',
  dropDownOptions: {
    multiple: true,
    dropdownValues: [
      { label: t('common:messageTypes.plural.ORDER'), value: DocumentTypeWithVirtual.order },
      {
        label: t('common:messageTypes.plural.ORDER_CONFIRMATION'),
        value: DocumentTypeWithVirtual.orderConfirmation,
      },
      {
        label: t('common:messageTypes.plural.ORDER_REJECTION'),
        value: DocumentTypeWithVirtual.orderRejection,
      },
      {
        label: t('common:messageTypes.plural.PARTIAL_ORDER_CONFIRMATION'),
        value: DocumentTypeWithVirtual.partialOrderConfirmation,
      },
      {
        label: t('common:messageTypes.plural.DISPATCH_INSTRUCTION'),
        value: DocumentTypeWithVirtual.dispatchInstruction,
      },
      {
        label: t('common:messageTypes.plural.DISPATCH_INSTRUCTION_RESPONSE'),
        value: DocumentTypeWithVirtual.dispatchResponse,
      },
      {
        label: t('common:messageTypes.plural.SHIPPING_NOTICE'),
        value: DocumentTypeWithVirtual.shippingNotice,
      },
      { label: t('common:messageTypes.plural.INVOICE'), value: DocumentTypeWithVirtual.invoice },
      {
        label: t('common:messageTypes.plural.CREDIT_NOTE'),
        value: DocumentTypeWithVirtual.creditNote,
      },
      {
        label: t('common:messageTypes.plural.DEBIT_NOTE'),
        value: DocumentTypeWithVirtual.debitNote,
      },
      {
        label: t('common:messageTypes.plural.SERVICE_INVOICE'),
        value: DocumentTypeWithVirtual.serviceInvoice,
      },
      {
        label: t('common:messageTypes.plural.REMITTANCE_ADVICE'),
        value: DocumentTypeWithVirtual.remittanceAdvice,
      },
      {
        label: t('common:messageTypes.plural.PRODUCT_CATALOG'),
        value: DocumentTypeWithVirtual.productCatalog,
      },
      {
        label: t('common:messageTypes.plural.INVENTORY_REPORT'),
        value: DocumentTypeWithVirtual.inventoryReport,
      },
      {
        label: t('common:messageTypes.plural.SALES_REPORT'),
        value: DocumentTypeWithVirtual.salesReport,
      },
      {
        label: t('common:messageTypes.plural.ACKNOWLEDGEMENT'),
        value: DocumentTypeWithVirtual.acknowledgement,
      },
      {
        label: t('common:messageTypes.plural.RECEIVAL_NOTICE'),
        value: DocumentTypeWithVirtual.receivalNotice,
      },
      { label: t('common:messageTypes.plural.UNKNOWN'), value: DocumentTypeWithVirtual.unknown },
    ].filter((option) => !exclude?.includes(option.value)),
  },
  eventDetails: {
    event: 'filter_changed',
    properties: {
      filter_type: 'documentType',
    },
  },
});
